import { render } from "./ManualDetail.vue?vue&type=template&id=f3869134&scoped=true"
import script from "./ManualDetail.vue?vue&type=script&lang=js"
export * from "./ManualDetail.vue?vue&type=script&lang=js"

import "./ManualDetail.vue?vue&type=style&index=0&id=f3869134&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3869134"]])

export default __exports__